<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :show="true"
    width="30%"
    @confirm="confirm"
    @closeDialog="close"
  >
    <el-form label-width="100px">
      <el-form-item label="公众号：">
        <el-input
          :placeholder="currentRowData.wechat_name"
          disabled
        />
      </el-form-item>
      <el-form-item :label="option">
        <el-select
          v-model.trim="currentRowData.advertiser_name"
          disabled
        />
      </el-form-item>
      <el-form-item label="开始时间：">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOption"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          @change="pickerTime"
        />
      </el-form-item>
      <el-form-item label="状态:">
        <el-select v-model="form.status">
          <el-option
            label="正常"
            :value="1"
          />
          <el-option
            label="停止"
            :value="2"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow'
export default {
  name: 'ModifyWechatUser',
  components: { GlobalWindow },
  props: {
    // 获取父组件筛选列表
    selectData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: '添加'
    },
    option: {
      type: String,
      default: '用户'
    }
  },
  data() {
    return {
      currentRowData: {},
      id: null,
      visible: false,
      timeValue: null,
      // 收集表单数据
      form: {
        start_time: null,
        end_time: null,
        status: 1
      },
      pickerOption: {
        disabledDate(time) {
          return time.getTime() < (Date.now() - (24 * 60 * 60 * 1000)) // > 是选择今天之前的时间  < 是选择今天之后 包括今天的时间
        }
      }
    }
  },
  methods: {
    open(data) {
      const { start_time, end_time } = data
      this.visible = true
      this.currentRowData = data // 获取当前行的数据
      this.id = data.id // 获取当前行的ID
      this.form.start_time = start_time
      this.form.end_time = end_time
      this.timeValue = [start_time, end_time]
      this.form.status = 1
    },
    // 关闭dialog
    close() {
      this.form = {}
      this.timeValue = null
    },
    confirm() {
      if (!this.id || !this.form.start_time || !this.form.end_time) {
        this.$message({
          message: '修改项不能为空',
          type: 'error'
        })
        return
      }
      this.$emit('confirm', this.id, this.form)
      this.form = {}
      this.timeValue = null
      this.visible = false
    },
    // 选择时间
    pickerTime() {
      if (!this.timeValue) return
      const [start_time, end_time] = this.timeValue
      this.form.start_time = start_time
      this.form.end_time = end_time
    }
  }
}
</script>

<style scoped>
</style>
